import { FeatureToggle, isFeatureToggleEnabled } from '@/hooks/useFeatureToggle';

export const getTgeMessageId = (): string =>
    isFeatureToggleEnabled(FeatureToggle.MAN_SCL_BRAKE_WEAR) ? 'intl-msg:fleetstatus.diagnostics.status.not_applicable' : 'intl-msg:fleetstatus.global.tge.data_available_soon';
